(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function getVariantId(card) {
    var select = qs(card, '[data-bff-acc-variant-select]');
    if (select && select.value) return select.value;
    var hidden = qs(card, '[data-bff-acc-variant]');
    return hidden ? hidden.value : '';
  }

  function getQty(card) {
    var input = qs(card, '[data-bff-acc-qty]');
    var q = parseInt(input && input.value, 10);
    if (!q || q < 1) return 1;
    return q;
  }

  function setQty(card, value) {
    var input = qs(card, '[data-bff-acc-qty]');
    if (!input) return;
    var q = Math.max(1, parseInt(value, 10) || 1);
    input.value = String(q);
  }

  function setFeedback(card, message, isError) {
    var el = qs(card, '[data-bff-acc-feedback]');
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.classList.toggle('bff-accessory-card__feedback--error', !!isError);
  }

  function updateCartCount(count) {
    var nodes = document.querySelectorAll('[data-bff-header-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = String(count);
    }
  }

  function sectionMsg(root, key, fallback) {
    var v = root && root.getAttribute(key);
    return v || fallback;
  }

  function initSection(root) {
    var tabs = qsa(root, '[data-bff-acc-tab]');
    var panels = qsa(root, '[data-bff-acc-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      for (var i = 0; i < tabs.length; i++) {
        var t = tabs[i];
        var active = t.getAttribute('data-bff-acc-tab') === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        var p = panels[j];
        var on = p.getAttribute('data-bff-acc-panel') === id;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function () {
        activate(this.getAttribute('data-bff-acc-tab'));
      });
    }

    var cards = qsa(root, '[data-bff-accessory-card]');
    for (var c = 0; c < cards.length; c++) {
      (function (card) {
        var addBtn = qs(card, '[data-bff-acc-add]');
        var sel = qs(card, '[data-bff-acc-variant-select]');
        var qtyInput = qs(card, '[data-bff-acc-qty]');
        var minusBtn = qs(card, '[data-bff-acc-qty-minus]');
        var plusBtn = qs(card, '[data-bff-acc-qty-plus]');

        function syncVariantUi() {
          if (!sel) return;
          var opt = sel.options[sel.selectedIndex];
          var priceEl = qs(card, '[data-bff-acc-price-value]');
          if (priceEl && opt && opt.getAttribute('data-price-label')) {
            priceEl.textContent = opt.getAttribute('data-price-label');
          }
          var avail = opt && !opt.disabled;
          if (addBtn) addBtn.disabled = !avail;
        }

        if (sel) {
          sel.addEventListener('change', syncVariantUi);
          syncVariantUi();
        }

        if (minusBtn) {
          minusBtn.addEventListener('click', function () {
            setQty(card, getQty(card) - 1);
          });
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            setQty(card, getQty(card) + 1);
          });
        }

        if (qtyInput) {
          qtyInput.addEventListener('blur', function () {
            setQty(card, qtyInput.value);
          });
        }

        if (!addBtn) return;

        addBtn.addEventListener('click', function () {
          var vid = getVariantId(card);
          if (!vid) {
            setFeedback(card, sectionMsg(root, 'data-bff-acc-select-msg', 'Select an option.'), true);
            return;
          }

          var qty = getQty(card);
          setFeedback(card, '', false);
          addBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
          })
            .then(function (res) {
              return res.json().then(function (data) {
                if (!res.ok) throw data;
                return data;
              });
            })
            .then(function () {
              return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              setFeedback(card, sectionMsg(root, 'data-bff-acc-added-msg', 'Added to cart.'), false);
            })
            .catch(function (err) {
              var msg =
                (err && err.description) ||
                (err && err.message) ||
                sectionMsg(root, 'data-bff-acc-error-msg', 'Could not add. Try again.');
              setFeedback(card, msg, true);
            })
            .finally(function () {
              if (sel) syncVariantUi();
              else addBtn.disabled = false;
            });
        });
      })(cards[c]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-bff-product-accessories]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  });
})();
